import * as api from './api';
import * as types from './mutations';

const state = {
    latestCourses: [],
    popularCourses: [],
    popularCollections: [],
    fetchedCourses: {},
    courseContent: {},
    isProcessing: false
};

const getters = {
    course(state) {
        return function (courseSlug) {
            return state.fetchedCourses[courseSlug] && state.fetchedCourses[courseSlug];
        }
    },

    relatedCourses(state) {
        return function (courseSlug) {
            return state.fetchedCourses[courseSlug] && state.fetchedCourses[courseSlug].relatedCourses.data;
        }
    },

    courseContent(state) {
        return function (courseSlug) {
            return state.courseContent[courseSlug];
        }
    },
};

const mutations = {
    [types.SET_PROCESSING_STATE](state, isProcessing) {
        state.isProcessing = isProcessing;
    },

    [types.SET_LATEST_COURSES](state, courses) {
        state.latestCourses = courses;
    },

    [types.SET_POPULAR_COURSES](state, courses) {
        state.popularCourses = courses;
    },

    [types.SET_POPULAR_COLLECTIONS](state, collections) {
        state.popularCollections = collections;
    },

    [types.UPDATE_FETCHED_COURSES](state, {courseSlug, courseData}) {
        state.fetchedCourses[courseSlug] = courseData;
    },

    [types.UPDATE_COURSES_CONTENT](state, {courseSlug, courseData}) {
        state.courseContent = {...state.courseContent, [courseSlug]: courseData};
    },

    [types.SET_COURSE_ASSESSMENT](state, {courseSlug, questions}) {
        state.courseContent[courseSlug] = {...state.courseContent[courseSlug], assessment: questions}
    }
};

const actions = {
    getLatestCourses({commit}) {
        axios.get(api.getLatestCourses)
            .then(({data}) => {
                commit(types.SET_LATEST_COURSES, data.courses.data);
            });
    },

    getPopularCourses({commit}) {
        axios.get(api.getPopularCourses)
            .then(({data}) => {
                commit(types.SET_POPULAR_COURSES, data.courses.data);
            });
    },

    getPopularCollections({commit}) {
        axios.get(api.getPopularCollections)
            .then(({data}) => {
                commit(types.SET_POPULAR_COLLECTIONS, data.collections.data);
            });
    },

    getCourseOverview({commit, state}, {courseSlug}) {
        // If course's overview has been fetched before
        // Then we simulate loading and return the cached course.
        if (state.fetchedCourses[courseSlug]) {
            commit(types.SET_PROCESSING_STATE, true);
            setTimeout(() => {
                return state.fetchedCourses[courseSlug];
            }, _.random(500, 1000));
        }
        
        return new Promise((resolve, reject) => {
            commit(types.SET_PROCESSING_STATE, true);

            axios.get(api.getCourseOverview(courseSlug))
                .then(({data}) => {
                    commit(types.UPDATE_FETCHED_COURSES, {courseSlug, courseData: data.course.data});
                    resolve(data.course.data);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    getCourseContent({commit, state}, {courseSlug}) {
        if (state.courseContent[courseSlug]) return state.courseContent[courseSlug];

        return new Promise((resolve, reject) => {
            commit(types.SET_PROCESSING_STATE, true);
            
            axios.get(api.getCourseContent(courseSlug))
                .then(({data}) => {
                    commit(types.UPDATE_COURSES_CONTENT, {courseSlug, courseData: data.course.data});
                    resolve(data.course.data);
                })
                .catch(({response}) => reject(response.data))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    getAssessmentQuestions({commit, state}, {courseSlug}) {
        return new Promise((resolve, reject) => {
            if (state.courseContent[courseSlug] && state.courseContent[courseSlug].assessment) {
                return resolve(state.courseContent[courseSlug].assessment);
            }

            commit(types.SET_PROCESSING_STATE, true);
            axios.get(api.getAssessmentQuestion(courseSlug))
                .then(({data}) => {
                    commit(types.SET_COURSE_ASSESSMENT, {courseSlug, questions: data.assessmentQuestions.data});
                    resolve(state.courseContent[courseSlug].assessment);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};